import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home  from './pages/Home';
import Blog  from './pages/Blog';
import Login from './pages/Login';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/"          element={<Home />} />
        <Route path="/blog"      element={<Blog />} />
        <Route path="/blog/:id"  element={<Blog />} />
        <Route path="/login"     element={<Login />} />
      </Routes>
    </AuthProvider>
  );
}
